export default __webpack_public_path__ + "static/media/success-icon.1f5499bb.PNG";